const User = () => import('../views/UserManage/user/index.vue');
export default [
  {
    path: '/promoter',
    name: '推用户管理',
    component: User,
    meta: [{ name: '用户管理' }],
  },
];